import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperplane32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconPaperplane32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25.93 17.763c1.415-.752 1.415-2.78 0-3.533L8.96 5.22c-1.47-.781-3.195.471-2.908 2.111l1.518 8.666-1.518 8.665c-.287 1.64 1.438 2.893 2.908 2.112zm-.939-1.766-16.968 9.01L9.426 17H16a1 1 0 1 0 0-2H9.427L8.023 6.986z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperplane32);
